export const EVENTS_DATA = {
    1: { // Fashion
        title: "Fashion",
        description: "Walk the ramp of dreams.",
        events: [
            { title: "Desi Vogue", type: "Fashion Show", desc: "Glitz, glamour, and style.", link: "https://unstop.com/o/AmZjL1v?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "Mr & Ms Samaarambh", type: "Pageant", desc: "Personality and poise.", link: null }
        ]
    },
    2: { // Pro Night (Was Live Events)
        title: "Pro Night",
        description: "The heartbeat of the carnival.",
        events: [
            { title: "Celebrity Singer", type: "Star Night", desc: "A night to remember.", link: null },
            { title: "Rock Band", type: "Concert", desc: "Electrifying beats.", link: null },
            { title: "DJ Night", type: "Party", desc: "Dance 'til you drop.", link: null }
        ]
    },
    3: { // Theatre
        title: "Theatre",
        description: "Stories brought to life.",
        events: [
            { title: "Rangmanch", type: "Mono Acting / Drama", desc: "Theatrical brilliance.", link: "https://unstop.com/o/2aPmSZV?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "Nukkad Natak", type: "Street Play", desc: "Social awareness with impact.", link: null },
            { title: "Mime", type: "Silent Art", desc: "Actions speak louder.", link: null }
        ]
    },
    4: { // Music
        title: "Music",
        description: "Melodies that transcend time.",
        events: [
            { title: "Sur Samaaroh", type: "Solo Singing", desc: "Voice of the carnival.", link: "https://unstop.com/o/JTgqk1l?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "Mic pe Mehfil", type: "Open Mic", desc: "Poetry, storytelling, and music.", link: null },
            { title: "Battle of Bands", type: "Flagship", desc: "Clash of the titans.", link: null }
        ]
    },
    5: { // Dance
        title: "Dance",
        description: "Rhythm, grace, and explosive energy.",
        events: [
            { title: "Nritya Tarang", type: "Solo Dance", desc: "Showcase your individual style.", link: "https://unstop.com/o/SPJMtLw?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "The Dance Darbaar", type: "Group Dance", desc: "Synchronized spectacle.", link: "https://unstop.com/o/SmD6jJd?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "Street Dance", type: "Battle", desc: "Raw urban energy.", link: null }
        ]
    },
    6: { // Creative Corners (Was Fine Arts)
        title: "Creative Corners",
        description: "Unleash your inner artist.",
        events: [
            { title: "Bhool Bhulayya", type: "Treasure Hunt", desc: "Solve the mystery.", link: null },
            { title: "Chitra Yatra", type: "Photography", desc: "Capture the moment.", link: "https://unstop.com/o/Nf97OYS?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "Drishyam", type: "Reel Making", desc: "Cinematic storytelling.", link: "https://unstop.com/o/FXfwJsP?lb=ZxyFOIOh&utm_medium=Share&utm_source=ashwiand7053&utm_campaign=Events" },
            { title: "Pottery", type: "Workshop", desc: "Mold your imagination.", link: "https://unstop.com/events/mitti-masti-the-pottery-workshop-samaarambh-100--1637951" },
            { title: "Candle Making", type: "Workshop", desc: "Light up your creativity.", link: "https://unstop.com/events/wick-wax-samaarambh-100--1644868" },
            { title: "Perfume Making", type: "Workshop", desc: "Scents of summer.", link: "https://unstop.com/events/aroma-alchemy-samaarambh-100--1644858" }
        ]
    }
};
